
<div class="contenedor-foot">
  <div class="container containFoot contenedorBlanco">
    <div class="conte-tel-img">
      <div class="conte-telefonos">
        <h5 class="titulo-sena-foot-2">Servicio Nacional de Aprendizaje SENA</h5>
        <h5 class="titulo-dir-general">Dirección General</h5>
        <p class="info">
          Calle 57 No. 8 - 69 Bogotá D.C. (Cundinamarca), Colombia
        </p>
        <p class="info">
          El SENA brinda a la ciudadanía, atención presencial en las 33 Regionales y 117 Centros de Formación
        </p>
        <p class="info">
          <a href="https://www.sena.edu.co/es-co/transparencia/Paginas/mecanismosContacto.aspx" alt="Ir a enlace para conocer los puntos de atención"
             matTooltip="Ir a enlace para conocer los puntos de atención" class="link-puntos-aten">
            Conozca aquí los puntos de atención
          </a>
        </p>
        <p class="info">
          Línea de atención al ciudadano: Bogotá +(57) 601 3430111 - Línea gratuita y resto del país 018000 910270
        </p>
        <p class="info">
          Línea de atención al empresario: Bogotá +(57) 601 3430101 - Línea gratuita y resto del país 018000 910682
        </p>
        <p class="info">
          Línea nacional, exclusiva para comunicarse con un servidor público SENA: +(57) 601 5461500
        </p>
      </div>
      <div class="conte-imagenes">
        <img class="logoSenaFoot" src="assets/img/footer/logo-sena-footer-Transparente.png" alt="Logo Sena" matTooltip="Logo Sena">
        <img class="logoIcontecFoot" src="assets/img/footer/logo-icontec-footerTransparente.png" alt="Somos certificados icontec ISO 14001, ISO 50001 e ISO 9001"
             matTooltip="Certificados Icontec" aria-label="Somos certificados icontec ISO 14001, ISO 50001 e ISO 9001">
      </div>
      <h5 class="titulo-sena-foot-1">Servicio Nacional de Aprendizaje SENA</h5>
    </div>

    <div class="conte-red-politicas">
      <div class="conte-redes">

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('@SENA','https://www.facebook.com/SENA/','_blank')"
           alt="Ir a página de Facebook del Sena" matTooltip="Ir a página de Facebook del Sena">
          <div class="icono-facebook">
            <i class="fab fa-facebook" alt="Logo Facebook"></i>
          </div>
          <div class="texto-icono">
            @SENA
          </div>
        </a>

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('@SENACOMUNICA','https://twitter.com/SENAComunica','_blank')"
           alt="Ir a página de Twitter del Sena" matTooltip="Ir a página de Twitter del Sena">
          <div class="social-icon">
            <i class="fab fa-twitter" alt="Logo Twitter"></i>
          </div>
          <div class="texto-icono">
            @SENACOMUNICA
          </div>
        </a>

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('@SENACOMUNICA','https://www.instagram.com/senacomunica/','_blank')"
           alt="Ir a página de Instagram del Sena" matTooltip="Ir a página de Instagram del Sena">
          <div class="social-icon">
            <i class="fab fa-instagram" alt="Logo Instagram"></i>
          </div>
          <div class="texto-icono">
            @SENACOMUNICA
          </div>
        </a>

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('@SENATV','https://www.youtube.com/user/SENATV','_blank')"
           alt="Ir a página de Youtube del Sena" matTooltip="Ir a página de Youtube del Sena">
          <div class="social-icon">
            <i class="fab fa-youtube" alt="Logo Youtube"></i>
          </div>
          <div class="texto-icono">
            @SENATV
          </div>
        </a>

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('@SENACOLOMBIA','https://soundcloud.com/senacolombia','_blank')"
           alt="Ir a página de Sound Clound del Sena" matTooltip="Ir a página de SoundClound del Sena">
          <div class="social-icon">
            <i class="fab fa-soundcloud" alt="Logo Sound Clound"></i>
          </div>
          <div class="texto-icono">
            @SENACOLOMBIA
          </div>
        </a>

        <a class="conte-i-text cursor-pointer" (click)="mostrarAlerta('3168760255','https://api.whatsapp.com/send/?phone=573168760255&text&app_absent=0','_blank')"
           alt="Ir a página de WhatsApp del Sena" matTooltip="Ir a página de WhatsApp del Sena">
          <div class="social-icon">
            <i class="fab fa-whatsapp" alt="Logo WhatsApp"></i>
          </div>
          <div class="texto-icono">
            3168760255
          </div>
        </a>

      </div>
      <div class="conte-politicas">

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/sena/Paginas/directorio.aspx"
           alt="Ir a página de Directorio SENA" matTooltip="Ir a página de Directorio SENA">
          Directorio SENA
        </a>

        <a class="enlace" target="_self" href="https://sciudadanos.sena.edu.co/SolicitudIndex.aspx"
           alt="Ir a página de PQRS" matTooltip="Ir a página de PQRS">
          PQRS
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/ciudadano/Paginas/chat.aspx"
           alt="Ir a página de Chat en línea" matTooltip="Ir a página de Chat en línea">
          Chat en línea
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/ciudadano/Paginas/Denuncias_Corrupcion.aspx"
           alt="Ir a página de Denuncias por actos de corrupción" matTooltip="Ir a página de Denuncias por actos de corrupción">
          Denuncias por actos de corrupción
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/transparencia/Paginas/mecanismosContacto.aspx#notificacionesJudiciales"
           alt="Ir a página de Notificaciones judiciales" matTooltip="Ir a página de Notificaciones judiciales">
          Notificaciones judiciales
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/Paginas/politicasCondicionesUso.aspx#derechoAutor"
           alt="Ir a página de Derechos de autor y/o autorización de uso sobre contenidos" matTooltip="Ir a página de Derechos de autor y/o autorización de uso sobre contenidos">
          Derechos de autor y/o autorización de uso sobre contenidos
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/Paginas/politicasCondicionesUso.aspx"
           alt="Ir a página de Términos y condiciones del portal web" matTooltip="Ir a página de Términos y condiciones del portal web">
          Términos y condiciones del portal web
        </a>

        <a class="enlace cursor-pointer" (click)="mostrarAlerta('Política de Tratamiento para Protección de Datos Personales','https://portal.senasofiaplus.edu.co/index.php/seguridad/politica-de-confidencialidad','_blank')"
           alt="Ir a página de Política de Tratamiento para Protección de Datos Personales" matTooltip="Ir a página de Política de Tratamiento para Protección de Datos Personales">
          Política de Tratamiento para Protección de Datos Personales
        </a>

        <a class="enlace cursor-pointer" (click)="mostrarAlerta('Política de seguridad y privacidad de la información','https://compromiso.sena.edu.co/index.php?text=inicio&id=27','_blank')"
           alt="Ir a página de Política de seguridad y privacidad de la información" matTooltip="Ir a página de Política de seguridad y privacidad de la información">
          Política de seguridad y privacidad de la información
        </a>

        <a class="enlace" target="_self" href="https://www.sena.edu.co/es-co/Paginas/mapaSitio.aspx"
           alt="Ir a página de Mapa del sitio" matTooltip="Ir a página de Mapa del sitio">
          Mapa del sitio
        </a>

      </div>
      <p tabindex="0" class="ultima-mod">Última modificación: 12/09/2023 11:00am</p>
      <button class="btn-link button-color btn-inicio" (click)="salida()" tabindex="0" role="button">
        Ir a la
        opción ingresar o cerrar sesión
      </button>
    </div>

  </div>
</div>

